import $ from 'jquery';

/**
 * Custom Scripts
 */
import Form from './custom/forms';
// import SocialMedia from './custom/bjzm-social-feeds';
import BjzmScripts from './custom/bjzm-scripts';
import Slider from './custom/bjzm-slideshow.js';

import BjzmLoadMorePosts from './custom/bjzm-load-more-posts';
import HeaderScroll from './custom/header-scroll';
import SinglePageUpdown from './custom/single-page-updown';
import BjzmFormScripts from './custom/bjzm-form-scripts';
import AppWebApiUtilities from './custom/app-web-api-utilities';

/**
 * Vendors
 */
import matchHeight from './vendors/jquery.matchHeight';
import magnificPopup from 'magnific-popup';


jQuery(document).ready(function($) {

 	var ThemeScripts = new BjzmScripts();
 	var RegisterFormScripts = new BjzmFormScripts();

	/* Load More Posts */
	var LoadMorePosts = new BjzmLoadMorePosts({
		query_vars: BJZM_DATA.query_vars,
		ajax_url: BJZM_DATA.ajaxurl,
		max_num_pages: BJZM_DATA.max_num_pages,
		post_loop: $(".bjzm-wrapper__row--blog-posts"),
		template_partial: 'content-full-width-article'
	});

	var subMenuScroll = new SinglePageUpdown({
		container: $(".header__logo, .hero__scroll-down-outer"),
		offset: 0,
		changeHash: false
	});

	/* Homepage Slideshow*/
	var HomeSlider = new Slider("home_slider", {
		dots: true,
		customPaging : function(slider, i) {
 			return '<a href="#" class="slider__dots"></a>';
 		}
 	});

	/*privacy policy*/
	$('.lightbox').magnificPopup({
 		type: 'inline',
		midClick: true,
		removalDelay: 300,
		mainClass: 'mfp-fade mfp-wrap--privacy-policy'
	});


	$(".show-hero").change(function(){
		$(".home-wrapper").toggleClass('hero-map');
	});

});









